module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"settingsTemplates":"Настройки шаблонов","editor":"Редактор письма"}}')
  delete Component.options._Ctor
}
